module.exports = __webpack_public_path__ + "static/segmentation.479d4d16.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/segmentation.png
// module id = 678
// module chunks = 193162123475590